<template>
  <select class="form-control m-1" v-model="param" @click="setParam(param)">
    <option value="Total">Total</option>
    <option value="Air">Air</option>
    <option value="Pollen">Pollen</option>
    <option value="Weather">Weather</option>
    <option value="Soil">Soil</option>
    <option value="Water_Vapour">Water</option>
    <option value="Fire">Fire</option>
    <option value="All">All</option>
  </select>
</template>

<script>
export default {
  data() {
    return {
      param: "Total",
    };
  },
  props: {
    summaryParam:
    {
    default : 'Total'
    }
  },
  methods: {
    setParam() {
      this.$emit("sendParam", this.param);
    },
  },
  watch:{
    summaryParam:{
      immediate : true,
      handler(v){
        this.param = v;
      }
    }
  }
};
</script>

<style>
</style>